const isExpired = expiresAt => {
  const now = new Date();
  const expiredDate = new Date(expiresAt);

  return now > expiredDate;
};

export default isExpired;
